import {
    PanelContainer,
    BgImage,
    BlurOverlay,
    InfoContainer,
    Title,
    ReleaseDateContainer,
    ReleaseDate,
    Moon,
} from './PullVaultPanel.styles.js';

export default function PullVaultPanel() {
    return (
        <a
            href="https://www.pull-vault.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'block', width: '100%', height: '100%' }}
        >
            <PanelContainer>
                <BgImage />
                
                <InfoContainer>
                    <Title>PULL VAULT</Title>
                    <ReleaseDateContainer>
                        <ReleaseDate>APR '26</ReleaseDate>
                        <Moon />
                    </ReleaseDateContainer>
                </InfoContainer>
                <BlurOverlay />
            </PanelContainer>
        </a>
    );
}
